module.exports = __webpack_public_path__ + "static/media/imperium.bbd600dc.png";